module.exports = __webpack_public_path__ + "static/media/van.5cbca73a.svg";